import React, { Component } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import moment from 'moment';
import ChangePostcodeModal from './Modals/ChangePostcodeModal';
import ShowMediaRollover from './Modals/ShowMediaRollover';
import OnHoldReminderModal from './Modals/OnHoldReminderModal';
import FlaggedModal from './Modals/FlaggedModal';

export default class Job extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showReminderModal: false,
            showFlaggedModal: false,
            specialRequests: props.job.special_requests ?? '',
            editingSpecialRequests: false,
            savingSpecialRequests: false, // Prevent double save
        };

        this.showPostcodeModal = this.showPostcodeModal.bind(this);
        this.showReminderModal = this.showReminderModal.bind(this);
        this.showFlaggedModal = this.showFlaggedModal.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.job.special_requests !== this.props.job.special_requests) {
            this.setState({
                specialRequests: this.props.job.special_requests ?? '',
            });
        }
    }

    showReminderModal(e, show) {
        e.stopPropagation();
        this.setState({ showReminderModal: show });
    }

    showPostcodeModal(e, show) {
        e.stopPropagation();
        this.setState({ showModal: show });
    }

    showFlaggedModal(e, show) {
        e.stopPropagation();
        this.setState({ showFlaggedModal: show });
    }

    handleSpecialRequestsSave = () => {
        const { job, updateSpecialRequests } = this.props;

        if (this.state.savingSpecialRequests) return;

        if (this.state.specialRequests !== job.special_requests) {
            this.setState({ savingSpecialRequests: true }, () => {
                updateSpecialRequests(job.id, this.state.specialRequests).finally(() => {
                    this.setState({ savingSpecialRequests: false });
                });
            });
        }
    };
    handleSpecialRequestsKeyDown = (e) => {
        const { job, updateSpecialRequests } = this.props;

        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            this.setState({ editingSpecialRequests: false });
            if (this.state.specialRequests !== job.special_requests) {
                updateSpecialRequests(job.id, this.state.specialRequests);
            }
        }
    };

    handleSpecialRequestsBlur = () => {
        const { job, updateSpecialRequests } = this.props;

        this.setState({ editingSpecialRequests: false });
        if (this.state.specialRequests !== job.special_requests) {
            updateSpecialRequests(job.id, this.state.specialRequests);
        }
    };

    render() {
        const { job, memberId, index } = this.props;

        let classes = job.sla === 1 ? 'flex-table border border-primary transform-text' : 'flex-table transform-text';
        classes =
            moment(job.execution_date) < moment().startOf('day')
                ? 'flex-table border border-danger transform-text'
                : classes;

        const address =
            job.address_line_1 +
            (job.address_line_2 ? `, ${job.address_line_2}` : '') +
            `, ${job.city}` +
            `, ${job.postcode}`;

        return (
            <Draggable draggableId={(memberId + '-' + job.id).toString()} index={index}>
                {(provided) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className={classes}
                        onClick={() => this.props.onClick(job)}
                        style={{
                            ...provided.draggableProps.style,
                            backgroundColor: job.special_requests ? '#fff3cd' : 'transparent',
                            width: '100%',
                        }}
                    >
                        <div className="flex-row" onClick={(e) => e.stopPropagation()}>
                            <input
                                type="checkbox"
                                checked={this.props.isSelected}
                                onClick={() => this.props.onJobSelect(job.id)}
                            />
                        </div>
                        <div className="flex-row">{new Date(job.created_at).toLocaleDateString('en-GB')}</div>
                        <div
                            className="flex-row"
                            style={{ fontSize: '11px', cursor: 'text' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                this.setState({ editingSpecialRequests: true });
                            }}
                        >
                            {this.state.editingSpecialRequests ? (
                                <textarea
                                    value={this.state.specialRequests}
                                    rows={2}
                                    autoFocus
                                    onMouseDown={(e) => e.stopPropagation()}
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={(e) => this.setState({ specialRequests: e.target.value })}
                                    onKeyDown={this.handleSpecialRequestsKeyDown}
                                    onBlur={this.handleSpecialRequestsBlur}
                                    style={{ width: '100%', fontSize: '11px', resize: 'none' }}
                                />
                            ) : (
                                <div style={{ whiteSpace: 'pre-wrap' }}>{this.state.specialRequests || '-'}</div>
                            )}
                        </div>

                        <div className="flex-row" style={{ fontSize: '10px' }}>
                            {address}
                        </div>

                        <div className="flex-row">
                            <div className="d-flex justify-content-center">
                                {!!job.app_job && (
                                    <div style={{ marginRight: 10 }}>
                                        <i className="fas fa-phone"></i>
                                    </div>
                                )}
                                <span>{job.id}</span>
                            </div>
                        </div>
                        <div className="flex-row">{job.job_type.name}</div>
                        <div className="flex-row">{job.customer.name}</div>

                        <div className="flex-row" onClick={(e) => e.stopPropagation()}>
                            <button
                                style={{ fontSize: 'medium' }}
                                onClick={(e) => this.showPostcodeModal(e, true)}
                                className="btn btn-link btn-info"
                                title="Change Location"
                            >
                                <i className="fas fa-edit"></i>
                            </button>
                            {job.two_person_team || job.admin_notes ? (
                                <button
                                    style={{ fontSize: 'medium' }}
                                    onClick={(e) => this.props.showModal(e, true, job)}
                                    className="btn btn-link btn-info"
                                    title="View Notes"
                                >
                                    <i className="far fa-file-text"></i>
                                </button>
                            ) : null}
                            {job.job_media.length > 0 && <ShowMediaRollover jobMedia={job.job_media} jobId={job.id} />}
                            {!job.on_hold_reminder && job.on_hold === 1 && (
                                <button
                                    style={{ fontSize: 'medium' }}
                                    onClick={(e) => this.showReminderModal(e, true)}
                                    className="btn btn-link btn-info"
                                    title="Add Reminder"
                                >
                                    <i className="fas fa-bell"></i>
                                </button>
                            )}
                            {job.flagged ? (
                                <button
                                    style={{ fontSize: 'medium' }}
                                    onClick={(e) => this.showFlaggedModal(e, true, job)}
                                    className="btn btn-link btn-info"
                                    title="Flagged"
                                >
                                    <i className="fas fa-flag" style={{ color: 'red' }}></i>
                                </button>
                            ) : (
                                <button
                                    style={{ fontSize: 'medium' }}
                                    onClick={(e) => this.showFlaggedModal(e, true, job)}
                                    className="btn btn-link btn-info"
                                    title="Add Flag"
                                >
                                    <i className="far fa-flag"></i>
                                </button>
                            )}
                        </div>

                        <div
                            className="flex-row"
                            onClick={(e) => e.stopPropagation()}
                            style={{ display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center' }}
                        >
                            <div style={{ flexShrink: 0 }}>
                                <div className="dropdown">
                                    <button
                                        className="btn btn-secondary dropdown-toggle"
                                        type="button"
                                        data-toggle="dropdown"
                                        disabled={!this.props.members || this.props.members.length === 0}
                                    >
                                        <i className="fas fa-plus-square-o"></i> Assign
                                    </button>
                                    <ul className="dropdown-menu" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                        {this.props.members?.map((member) => (
                                            <li key={member.id}>
                                                <button
                                                    className="dropdown-item"
                                                    onClick={() => this.props.quickAssign(job.id, member.value)}
                                                >
                                                    {member.label}
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            {this.props.unassignJob && (
                                <div style={{ flexShrink: 0 }}>
                                    <div className="dropdown">
                                        <button
                                            className="btn btn-danger btn-sm dropdown-toggle"
                                            type="button"
                                            data-toggle="dropdown"
                                        >
                                            Unassign
                                        </button>
                                        <div className="dropdown-menu">
                                            <button
                                                className="dropdown-item"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.props.unassignJob(job.id, memberId, 'unassigned');
                                                }}
                                            >
                                                Move to Today
                                            </button>
                                            <button
                                                className="dropdown-item"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.props.unassignJob(job.id, memberId, 'onHold');
                                                }}
                                            >
                                                Move to On Hold
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {this.state.showModal && (
                            <ChangePostcodeModal
                                show={this.state.modalShow}
                                onHide={this.showPostcodeModal}
                                job={job}
                            />
                        )}
                        {this.state.showReminderModal && (
                            <OnHoldReminderModal
                                show={this.state.modalShow}
                                onHide={this.showReminderModal}
                                job={job}
                            />
                        )}
                        {this.state.showFlaggedModal && (
                            <FlaggedModal show={this.state.modalShow} onHide={this.showFlaggedModal} job={job} />
                        )}
                    </div>
                )}
            </Draggable>
        );
    }
}
